import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const getWholeSalePlanned = (year, month) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/whole-sale/planned?year=${year}&month=${month}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WHOLE_SALE_PLANNED,
        ActionTypes.FETCHED_WHOLE_SALE_PLANNED,
        [ActionTypes.FETCHED_WHOLE_SALE_PLANNED_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const saveWholeSalePlanned = (data, year, month) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/whole-sale/planned',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_WHOLE_SALE_PLANNED,
        [
          () => {
            dispatch(getWholeSalePlanned(year, month));
            return {
              'type': ActionTypes.ADDED_WHOLE_SALE_PLANNED,
            };
          },
          (response) => buildSuccessMessage(response, 'Registros Guardados'),
        ],
        [ActionTypes.ADDED_WHOLE_SALE_PLANNED_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};
